module.exports = __webpack_public_path__ + "img/map_toilet_5@2x.f56ad22c.png";